// 鍏敤js锛屽缓璁娇鐢↖IFE锛堢珛鍗虫墽琛屽嚱鏁帮級
(function () {
   document.write(
    `<script>
      (function(win, export_obj) {
        win['LogAnalyticsObject'] = export_obj;
        if (!win[export_obj]) {
            var _collect = function() {
                _collect.q.push(arguments);
            }
            _collect.q = _collect.q || [];
            win[export_obj] = _collect;
        }
        win[export_obj].l = +new Date();
      })(window, 'collectEvent')
    </script>`+
    '<script async src="https://lf3-data.volccdn.com/obj/data-static/log-sdk/collect/5.0/collect-rangers-v5.1.8.js"></script>'+
    '<script language=javascript src="../static/js/jquery.qrcode.min.js"></script>'+
    '<script language=javascript src="../static/js/crypto.js"></script>'+
    '<script language=javascript src="../static/js/jsencryptv2.js"></script>'+
    '<script language=javascript src="../static/js/encrypt.js"></script>'+
    '<link rel="stylesheet" href="../static/css/viewer.css">'
  );

  $(document).ready(function () {
    // 妫€鏌ュ厓绱犳槸鍚﹀瓨鍦╘r
    var videoElement = document.querySelector('.video video');
    if (videoElement) {
      // 绂佺敤鍙抽敭鑿滃崟
      videoElement.addEventListener('contextmenu', function (e) {
        e.preventDefault(); // 闃绘鍙抽敭鑿滃崟
      });

      // 绂佺敤榧犳爣鎮仠鏃剁殑涓嬭浇鎻愮ず
      videoElement.addEventListener('mouseover', function (e) {
        e.preventDefault(); // 闃绘榛樿鐨勯紶鏍囨偓鍋滆涓篭r
      });
    }
  });

  window.collectEvent('init', {
    app_id: 20002352, // 鍙傝€?.1鑺傝幏鍙栵紝娉ㄦ剰绫诲瀷鏄痭umber鑰岄潪瀛楃涓瞈r
    channel_domain: 'https://collect.yineng.com.cn/track/api', // 璁剧疆鏁版嵁涓婇€佸湴鍧€
    log: false, // true:寮€鍚棩蹇楋紝false:鍏抽棴鏃ュ織
    autotrack: false, // 鍏ㄥ煁鐐瑰紑鍏筹紝true寮€鍚紝false鍏抽棴
  });
  // 姝ゅ鍙坊鍔犺缃畊uid銆佽缃叕鍏卞睘鎬х瓑浠ｇ爜
  window.collectEvent('start'); // 閫氱煡SDK璁剧疆瀹屾瘯锛屽彲浠ョ湡姝ｅ紑濮嬪彂閫佷簨浠朵簡

  if ($('.last-page').length > 0) {
    var lastHref = $('.last-page').attr('href');
    var tempHref1 = lastHref.split('-')[0];
    var tempHref2 = lastHref.split('-')[1];
    var lastPageNum = parseInt(tempHref2.split('.')[0]);
    $('.yn-pagination .last-page').after(
      '<span class="page-num total-page-num" >鍏? +
        lastPageNum +
        '椤袋/span><span class="page-num go-page"  style="cursor: pointer;">杞埌</span><span class="page-num" style="padding-left:5px;padding-right:5px;"><input name="pageinput" type="text" class="page-input" style="border:none; width:50px;  outline: none; text-align:center;"></span>'
    );
    $('.yn-pagination .go-page').on('click', function () {
      var pageNum = parseInt($('.page-input').val());

      if (pageNum === '') {
        alert('璇疯緭鍏ラ〉鐮侊紒');
        return false;
      }
      if (isNaN(pageNum) || pageNum <= 0 || pageNum > lastPageNum) {
        alert('璇疯緭鍏ユ纭〉鐮侊紒');
        return false;
      }
      toHref = tempHref1 + '-' + pageNum + '.html';
      window.location.href = toHref;
    });
  }
 // 涓嬭浇鍒楄〃
  var host = '';
  var downloadPath = '';
  var agent = navigator.userAgent.toLowerCase();

  // 鏍规嵁鐐瑰嚮鎸夐挳鑾峰彇涓嬭浇鍦板潃
  function getDownloadUrl($elem) {
    var downId = $elem.attr('down');
    switch (downId) {
      case '1':
        if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
          downloadPath = '/home/app/microlecturer/soft/?id=1';
        } else {
          downloadPath = '/home/app/microlecturer/soft/?id=3';
        }
        break;
      case '2':
        downloadPath = '/home/app/microlecturer/soft/?id=4';
        break;
      case '3':
        downloadPath = '/home/app/microlecturer/soft/?id=5';
        break;
      default:
        downloadPath = '/home/app/microlecturer/soft/?id=1';
        break;
    }
  }
   // 瀹氫箟鎸夐挳鐐瑰嚮澶勭悊鍑芥暟
  async function handleDownloadClick(e) {
    e.preventDefault();
    var $btn = $(this);
    getDownloadUrl($btn);
    var way = $btn.attr('way');

    $.ajax({
      type: 'get',
      url: host + downloadPath,
      crossDomain: true == !document.all,
      data: {},
      success: function (res) {
        console.log(res);
        // 鑾峰彇褰撳墠鎸夐挳鎵€鍦ㄧ殑瀹瑰櫒锛屼互渚挎壘鍒板搴旂殑闅愯棌涓嬭浇閾炬帴
        var el = $btn.closest('.download-buttons, .type');
        var data = res.result.data;
        $.ajax({
          type: 'get',
          url: data.record_url,
          success: function (subres) {
            // 鎵ц涓嬭浇
            var subData = subres.result.data;
            if (subData) {
              // 鏍规嵁 way 瀛楁鍖归厤 subData 涓殑灞炴€r
              // way="download_url1" -> subData.download_url1
              // way="download_url2" -> subData.download_url2
              var downloadLink = subData[way];
              if (downloadLink) {
                 // 濡傛灉鎵句笉鍒伴殣钘忕殑 down-url锛屽皾璇曞垱寤轰竴涓垨鐩存帴璺宠浆
                 var $downUrl = el.find('.down-url');
                 if ($downUrl.length === 0) {
                    // 濡傛灉鏄湪 .type 瀹瑰櫒閲屽彲鑳芥病鏈夐缃 down-url锛屾垨鑰呯洿鎺ョ敤 window.location
                    window.location.href = downloadLink;
                 } else {
                    $downUrl.attr('href', downloadLink);
                    $downUrl.find('span').click();
                 }
              }
            }
          },
        });
      },
    });
    // 涓婃姤鐏北
    const encryptedResult = await hybridEncrypt({
      source: '渚濊兘棰嗚瀹樼綉',
      school_name: '渚濊兘棰嗚'
    });
    window.collectEvent('install_click_download', encryptedResult);
  }

    $.getJSON('../config/config.json', function (data, textStatus, jqXHR) {
    host = data.host
    // 缁戝畾鐐瑰嚮浜嬩欢
    $('.down-btn').on('click', handleDownloadClick);

    // 妫€鏌RL鏄惁鍖呭惈download-now锛屽鏋滄槸鍒欒Е鍙慴tn1鐐瑰嚮
    if (window.location.href.indexOf('download-now') !== -1) {
      $('.btn1.down-btn').trigger('click');

      // 绉婚櫎URL涓殑?download-now=true鍙傛暟
      var cleanUrl = window.location.href.split('?')[0];
      window.history.replaceState({}, document.title, cleanUrl);
    }
  });
})();

//# sourceMappingURL=module.js.map
